import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'play',
	prefix: 'play',
	key: 'play_id',
	fields: {
		play_id: Model.SCHEMA_KEY,
		game_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		play_date: Model.SCHEMA_NUMBER,
		play_location: Model.SCHEMA_TEXT,
		play_length: Model.SCHEMA_NUMBER,
		play_players: Model.SCHEMA_NUMBER,
		play_count: Model.SCHEMA_NUMBER,
		play_result: Model.SCHEMA_NUMBER,
		play_won: Model.SCHEMA_NUMBER,
		play_comment: Model.SCHEMA_TEXT,
		play_incomplete: Model.SCHEMA_NUMBER,
		play_expansion: Model.SCHEMA_NUMBER
	},
	methods: {
		to_array: function() {
			return {
				id: parseInt(this.get_id() || 0, 10),
				date: parseInt(this.get_date() || 0, 10),
				length: parseInt(this.get_length() || 0, 10),
				location: this.get_location() || '',
				count: parseInt(this.get_count() || 0, 10),
				user: parseInt(this.get_user_id() || 0, 10),
				game: parseInt(this.get_game_id() || 0, 10),
				comment: String(this.get_comment() || '').replace(/\n/g, '<br />'),
				incomplete: parseInt(this.get_incomplete() || 0, 10),
				expansion: parseInt(this.get_expansion() || 0, 10)
			}
		}
	}
})
